export const ACTION_PREFIX = 'MODULE/PROPERTY'
